import { render } from "./NewDetails.vue?vue&type=template&id=d307d99e&scoped=true"
import script from "./NewDetails.vue?vue&type=script&lang=js"
export * from "./NewDetails.vue?vue&type=script&lang=js"

import "./NewDetails.vue?vue&type=style&index=0&id=d307d99e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d307d99e"]])

export default __exports__